export interface IMapLatLngZoomState {
  mapLatLng: [number, number];
  mapZoom: number;
}

export const DefaultMapLatLngZoomState = {
  mapLatLng: [33.98896188501714, -80.97254291612995],
  mapZoom: 8
};
